import { render, staticRenderFns } from "./InternalTransfer.vue?vue&type=template&id=3e36350d"
import script from "./InternalTransfer.vue?vue&type=script&lang=js"
export * from "./InternalTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports